import { LandingPageConfig } from 'rangeConfig/@types';
import smastadBgImage from '../../views/LandingPage/images/SMASTAD_background.jpg';
import designFromScratch from '../../views/LandingPage/images/smastadDesignFromScratchBright.png';
import smastadOpenDesignImg from '../../views/LandingPage/images/smastad_landing_open_design.jpg';
import smastadBrowseInspirationImg from '../../views/LandingPage/images/smastad_browse_inspiration.jpg';
import smastadGalleryConfig from './smastadGalleryConfig';

const smastadLandingPageConfig: LandingPageConfig = {
  rangeDesign: {
    backgroundImgUrl: smastadBgImage
  },
  designFromScratch: {
    backgroundColor: '#F6DFAA',
    backgroundImgUrl: designFromScratch
  },
  openDesign: {
    backgroundColor: '#F5F5F5',
    backgroundImgUrl: smastadOpenDesignImg
  },
  browseInspiration: {
    backgroundColor: '#D4E8E6',
    backgroundImgUrl: smastadBrowseInspirationImg,
    galleryConfig: smastadGalleryConfig
  }
};

export default smastadLandingPageConfig;
